import { mapGetters } from 'vuex'
import { getterTypes } from '@/store/modules/configuration'
import { getterTypes as getterTypesLanguagePack } from '@/store/modules/language-pack'

export default {
    computed: {
        ...mapGetters('configuration', { lang: getterTypes.getLanguageShort }),
        ...mapGetters('languagePack', {
            getTextForSelected: getterTypesLanguagePack.getContent,
        }),
        extraContent: function () {
            return this.getTextForSelected(this.lang, 'orderExtra') || ''
        },
        isRtl: function () {
            return this.lang === 'he'
        },
    },
}
